<template>
  <div class="protocol-page">
    <div v-for="item in content" v-bind:id="item.key">
      <h3 v-if="hasContent(item)" v-bind:id="item.key + '-header'">
        {{ item.header }}
      </h3>
      <div v-html="item.content" v-bind:id="item.key + '-content'"></div>
    </div>
  </div>
</template>

<script>
  import showdown from 'showdown'

  export default {
    name: 'Protocol',
    props: ['protocol', 'headers'],
    data () {
      return {
        markdown: this.protocol.markdown
      }
    },
    computed: {
      content () {
        return this.headers
                .filter((header) => {
                  const headerKey = header[0] // eg "time-estimate"
                  return headerKey in this.markdown && !!this.markdown[headerKey]
                })
                .map((item) => {
                  const headerKey = item[0]
                  const displayText = item[1]
                  return {
                    key: headerKey,
                    header: displayText,
                    content: this.makeHtml(this.markdown[headerKey])
                  }
                })
      }
    },
    methods: {
      makeHtml (markdown) {
        return new showdown.Converter().makeHtml(markdown)
      },
      hasContent (item) {
        return item.content !== ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Protocol.vue?88a6cc40